const {
  getCurrencyToLocale,
} = require("../../src/client-ts/utils/currency.ts");

exports._getCurrencySymbol = (currency) => getCurrencyToLocale(currency);
